import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';
import { bem } from 'helpers/class-name';
import { Card } from 'components/Card';
import Message from 'components/Message';
import './FeatureNotSupported.scss';

const messages = defineMessages({
  notSupported: {
    id: 'feature-not-supported',
    defaultMessage: 'This feature is currently not supported for this venue.',
  },
});

const { block } = bem('feature-not-supported');

const FeatureNotSupported = ({ className }) => (
  <Card className={block('text--center text--light', className)} centered>
    <Message message={messages.notSupported} />
  </Card>
);

FeatureNotSupported.propTypes = {
  className: PropTypes.string,
};

export default FeatureNotSupported;
